import { SECTION } from "./section.js";
import { CHILDTABLE } from "../childtable.js";
import { FIELD } from "./field.js";
export const FORM_THEME_MODEL = {
  ...FIELD,
  ...SECTION,
  ...CHILDTABLE
};
